import React from 'react';
import Paper from 'material-ui/Paper';
import MainNavigation from 'layoutComponents/MainNavigation';
import Footer from 'containers/Footer';
export default class HomePage extends React.Component {

    render() {
        return (
            <Paper zDepth={3}>
                <MainNavigation/>
                <Footer/>
            </Paper>

        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/pages/HomePage.js